import { render, staticRenderFns } from "./TaxInvoicesList.vue?vue&type=template&id=3e5b7dd8&"
import script from "./TaxInvoicesList.vue?vue&type=script&lang=js&"
export * from "./TaxInvoicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaxInvoicesList.vue"
export default component.exports